import api from "../services/api";

export const makePayment = (data) => {
    return api.post('/company/subscription/packages/purchase',
        {...data}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const upgradePayment = (data) => {
    return api.post('/company/subscription/packages/upgradePlan',
        {...data}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const subscriptionPackageList = (queryParams) => {
    return api.get(`/company/subscription/packages/list${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const companyPaymentResourceList = (queryParams) => {
    return api.get(`/company/subscription/payment/resourceList${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const subscriptionPackageDetail = (queryParams) => {
    return api.get(`/company/subscription/packages/details${queryParams}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}